import { Divider, SimpleGrid, Stack, Text } from "@mantine/core";
import { Brand, Collab, User, UserType } from "../../../../gql/__generated__/graphql";
import CollabCard from "./CollabsCard/CollabsCard";

interface CollabsListProps {
  collabs: Collab[];
  role: UserType;
  onReview: (entity: User | Brand) => void;
}

function CollabsList(props: CollabsListProps) {
  const handleMessage = (collabId: string) => {
    console.log("Message for collab:", collabId);
    // Implement messaging logic
  };

  // Filter collabs that require action from the current user
  const actionRequiredCollabs = props.collabs.filter(
    (collab) =>
      (props.role === "BRAND_USER" &&
        collab.actionRequiredBy === "BRAND_USER") ||
      (props.role === "CREATOR" && collab.actionRequiredBy === "CREATOR")
  );

  // Filter collabs that are awaiting response (no action required from current user)
  const awaitingResponseCollabs = props.collabs.filter(
    (collab) =>
      !(
        (props.role === "BRAND_USER" &&
          collab.actionRequiredBy === "BRAND_USER") ||
        (props.role === "CREATOR" && collab.actionRequiredBy === "CREATOR")
      )
  );

  if (props.collabs.length === 0) {
    return (
      <Text ta="center" c="dimmed" py="xl">
        No collabs found
      </Text>
    );
  }

  return (
    <Stack gap="md" data-component="CollabsList">
      {actionRequiredCollabs.length > 0 && (
        <>
          <Text fw={500} size="lg">
            Action Required ({actionRequiredCollabs.length})
          </Text>
          <SimpleGrid
            cols={{ base: 1, sm: 2, md: 3 }}
            spacing="md"
            verticalSpacing="md"
          >
            {actionRequiredCollabs.map((collab) => (
              <CollabCard
                key={collab.id}
                collab={collab}
                userRole={props.role}
                onReview={props.onReview}
              />
            ))}
          </SimpleGrid>
          {awaitingResponseCollabs.length > 0 && <Divider my="md" />}
        </>
      )}

      {awaitingResponseCollabs.length > 0 && (
        <>
          <Text fw={500} size="lg">
            Awaiting Response ({awaitingResponseCollabs.length})
          </Text>
          <SimpleGrid
            cols={{ base: 1, sm: 2, md: 3 }}
            spacing="md"
            verticalSpacing="md"
          >
            {awaitingResponseCollabs.map((collab) => (
              <CollabCard
                key={collab.id}
                collab={collab}
                userRole={props.role}
                onReview={props.onReview}
              />
            ))}
          </SimpleGrid>
        </>
      )}
    </Stack>
  );
}

export default CollabsList;
